export default __webpack_public_path__ + "static/cafe_36064-4a749421f9af94c858189c8d272e810f.png";